import React from 'react';
import {
  LayoutGrid,
  Receipt,
  CreditCard,
  Vault,
  Package,
  Wrench,
  Shield,
} from 'lucide-react';
import { ACTIVITE_TAB_IDS } from '../../utils/activite/activityTabs';

const TAB_ICONS = {
  [ACTIVITE_TAB_IDS.OVERVIEW]: LayoutGrid,
  [ACTIVITE_TAB_IDS.VENTES]: Receipt,
  [ACTIVITE_TAB_IDS.PAIEMENTS]: CreditCard,
  [ACTIVITE_TAB_IDS.CAISSE]: Vault,
  [ACTIVITE_TAB_IDS.STOCK]: Package,
  [ACTIVITE_TAB_IDS.REPARATIONS]: Wrench,
  [ACTIVITE_TAB_IDS.EQUIPE]: Shield,
};

function TabButton({ tab, active, onClick, layout }) {
  const Icon = TAB_ICONS[tab.id] || LayoutGrid;
  const isBottom = layout === 'bottom';

  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={() => onClick(tab.id)}
      className={
        isBottom
          ? `flex flex-col items-center justify-center gap-1 flex-1 min-h-[56px] py-2 text-[10px] font-semibold transition-colors ${
              active ? 'text-red-400' : 'text-gray-500'
            }`
          : `px-3 py-2 min-h-[44px] rounded-xl text-sm font-semibold whitespace-nowrap border transition-colors shrink-0 ${
              active
                ? 'border-red-500/50 bg-red-950/30 text-white'
                : 'border-white/10 text-gray-400 hover:border-white/20 hover:text-gray-200'
            }`
      }
      data-testid={`activite-tab-${tab.id}`}
    >
      <Icon className={isBottom ? 'w-5 h-5' : 'w-4 h-4 inline mr-1.5'} />
      {isBottom ? <span className="truncate max-w-[4.5rem]">{tab.label}</span> : tab.label}
    </button>
  );
}

export default function ActiviteTabBar({ tabs, activeTab, onTabChange }) {
  const desktopTabs = tabs;
  const mobileNavTabs = tabs.filter((t) => t.mobileNav !== false && !t.carlosOnly);

  return (
    <>
      <div
        className="hidden lg:flex flex-wrap gap-2 mb-4 overflow-x-auto pb-1"
        role="tablist"
        data-testid="activite-tab-bar-desktop"
      >
        {desktopTabs.map((tab) => (
          <TabButton
            key={tab.id}
            tab={tab}
            active={activeTab === tab.id}
            onClick={onTabChange}
            layout="desktop"
          />
        ))}
      </div>

      <div
        className="lg:hidden flex gap-1 overflow-x-auto mb-4 pb-1 -mx-1 px-1"
        role="tablist"
        data-testid="activite-tab-bar-tablet"
      >
        {desktopTabs.map((tab) => (
          <TabButton
            key={tab.id}
            tab={tab}
            active={activeTab === tab.id}
            onClick={onTabChange}
            layout="desktop"
          />
        ))}
      </div>

      <div
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-[#151820] px-2 pt-1 pb-2 safe-area-pb"
        role="tablist"
        data-testid="activite-tab-bar-mobile"
      >
        <div className="flex max-w-lg mx-auto">
          {mobileNavTabs.slice(0, 4).map((tab) => (
            <TabButton
              key={tab.id}
              tab={tab}
              active={activeTab === tab.id}
              onClick={onTabChange}
              layout="bottom"
            />
          ))}
        </div>
      </div>
    </>
  );
}
